import * as types from './constants';

// Get Discover Brands
export const getDiscoverBrandsRequest = data => (
  { type: types.GET_DISCOVER_BRANDS_REQUEST, payload: data }
);

export const getDiscoverBrandsDone = data => (
  { type: types.GET_DISCOVER_BRANDS_DONE, payload: data }
);

export const getDiscoverBrandsFailed = errors => (
  { type: types.GET_DISCOVER_BRANDS_FAILED, payload: errors }
);

export const getDiscoverBrandsReset = () => (
  { type: types.GET_DISCOVER_BRANDS_RESET }
);

// Operations

export const discoverBrandsSetPage = data => (
  { type: types.DISCOVER_BRANDS_SET_PAGE, payload: data }
);